


























































import {
    Component,
    ComponentStyle,
    ComponentStyleDefinition,
    InjectComponent, Mixins,
    Prop,
    VueComponent,
    FileUploadQuestion, ActionPhase,
} from "@zoovu/runner-browser-api";
import QuestionBaseMixin from "./question-base.vue";
import {FileUploadImage} from "./types";
import { IconCross } from "./svgs";

@Component({
    components: { IconCross }
})
export default class FileUploadQuestionView extends Mixins(QuestionBaseMixin) {
    @InjectComponent("QuestionValidationMessageView")
    questionValidationMessageView: VueComponent;

    @InjectComponent("BaseSvg")
    baseSvg: VueComponent;

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    @Prop()
    question: FileUploadQuestion;

    loading = false;

    numberOfFilesIsExceeding = false;

    someFileSizeIsExceedingLimit = false;

    selectedFiles = [];

    someFileIsNotImage = false;

    fileUploadImages: FileUploadImage[] = [];

    fileUploadInfoIsShown = false;

    get fileUploadInfo(): string {
        return this.$t("message-file-upload-question-max-filesize")
    }

    get maxFileSizeInBytes(): number {
        return this.question.fileSize * 1024 * 1024;
    }

    get validFilesOnly(): FileUploadImage[] {
        return this.fileUploadImages.filter(({file}, index) =>
            this.question.extensions.indexOf(file.type.split("/")[1]) > -1 &&
            file.size <= this.maxFileSizeInBytes
        ).splice(0, this.question.maxFiles);
    }

    showFileUploadInfo(): void {
        this.fileUploadInfoIsShown = true;
    }

    hideFileUploadInfo(): void {
        this.fileUploadInfoIsShown = false;
    }

    mounted(): void {
        // as file upload input does not allow to preset value - we simply reset the whole question on mounted
        this.question.reset();

        this.question.onActionEventOnce("setFileUrls", ActionPhase.before, () => {
            this.loading = true;
        });
        this.question.onActionEventOnce("setFileUrls", ActionPhase.afterActionSession, () => {
            this.loading = false;
            this.$root.$emit("files-uploaded");
        });
    }

    onClickFileInput(event: Event): void {
        if (this.$refs.file) {
            this.$refs.file.value = '';
        }
    }

    onChangeFileInput(event: Event): void {
        this.selectedFiles = this.fileUploadImages;
        this.fileUploadImages = Array.from(event.target.files).map(file => {
            const URL = window.URL || window.webkitURL;
            let thumbnail = "";
            if (URL && URL.createObjectURL) {
                thumbnail = URL.createObjectURL(file);
            }
            return {
                file,
                thumbnail
            }
        });

        if (event.target.files.length) {
            this.selectedFiles = this.fileUploadImages;
            this.validateFiles();
            this.setQuestionSelection();
        } else {
            this.fileUploadImages = this.selectedFiles;
        }
    }

    setQuestionSelection(): void {
        this.question.setSelectedFiles([]);
        const validFilesOnly = this.validFilesOnly.map(({file}) => {
            return file
        });
        this.question.setSelectedFiles(validFilesOnly);
    }

    validateFiles(): void {
        this.numberOfFilesIsExceeding = this.fileUploadImages.length > this.question.maxFiles;
        this.someFileSizeIsExceedingLimit = this.fileUploadImages.some(({file}) => file.size > this.maxFileSizeInBytes);
        this.someFileIsNotImage = this.fileUploadImages.some(({file}) => this.question.extensions.indexOf(file.type.split("/")[1]) === -1);
    }

    onClickRemove(fileName: string): void {
        this.fileUploadImages = this.validFilesOnly.filter(({file}) => file.name !== fileName);
        this.validateFiles();
        this.setQuestionSelection();
    }
}
